import request from '@/utils/request'

//增加项目
export function projectAdd(data) {  
    data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
    return request({
      url: '/api/project/add',
      method: 'post',
      data
    })
  }
  
  //更新项目
  export function projectUpdate(data) {  
    data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
    return request({
      url: '/api/project/edit',
      method: 'post',
      data
    })
  }
  
  //删除项目
  export function projectDelete(data) {  
    data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
    return request({
      url: '/api/project/delete',
      method: 'post',
      data
    })
  }
  
  
  //增加业务集合
  export function projectCollectionsAdd(data) {  
    data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
    return request({
      url: '/api/project/addcollections',
      method: 'post',
      data
    })
  }
  
  //删除业务集合
  export function projectCollectionsDelete(data) {  
    data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
    return request({
      url: '/api/project/deletecollections',
      method: 'post',
      data
    })
  }


 //查询domain
 export function projectDomainList(data) {  
    data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
    return request({
      url: '/api/project/projectdomain',
      method: 'post',
      data
    })
  }



//编辑
export function projectCollectionsUpdate(data) {  
    data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
    return request({
      url: '/api/project/editcollections',
      method: 'post',
      data
    })
  }
  
  //更新绑定变量信息，目前主要是排序
  export function projectUpdateBindVar(data) {  
    data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
    return request({
      url: '/api/project/editprojectbindvar',
      method: 'post',
      data
    })
  }


  //绑定项目
  export function projectAddBindVar(data) {  
    data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
    return request({
      url: '/api/project/addprojectbindvar',
      method: 'post',
      data
    })
  }

  //删除变量
  export function DeleteProjectBindVarAsync(data) {  
    data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
    return request({
      url: '/api/project/deleteprojectbindvar',
      method: 'post',
      data
    })
  }

  

  //查询变量
  export function projectDeviceVarsList(data) {  
    data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
    return request({
      url: '/api/project/projectdevicevarslist',
      method: 'post',
      data
    })
  }

  


export function projectList(data) {  
    data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
    return request({
      url: '/api/project/projectlist',
      method: 'post',
      data
    })
  }
  //业务列表
  export function protocolbusinessList(data) {  
    data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
    return request({
      url: '/api/project/protocolbusiness',
      method: 'post',
      data
    })
  }

  
  //得业务信息
  export function projectCollections(data) {  
    data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
    return request({
      url: '/api/project/projectcollections',
      method: 'post',
      data
    })
  }

  ///得变量
  export function projectCollectionsDomainVars(data) {  
    data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
    return request({
      url: '/api/project/projectcollectionsdomainvars',
      method: 'post',
      data
    })
  }
  

  //得群组信息
  export function projectCollectionsDomainGroups(data) {  
    data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
    return request({
      url: '/api/project/projectcollectionsdomaingroups',
      method: 'post',
      data
    })
  }
  

  ///查询联动信息
  export function ProjectBindLinkageGet (data) {  
    data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
    return request({
      url: '/api/project/queryprojectbindlinkage',
      method: 'post',
      data
    })
  }
  //增加联动变量
  export function ProjectBindLinkageAdd (data) {  
    data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
    return request({
      url: '/api/project/addprojectbindlinkage',
      method: 'post',
      data
    })
  }
  //删除联动变量
  export function ProjectBindLinkageDelete (data) {  
    data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
    return request({
      url: '/api/project/deleteprojectbindlinkage',
      method: 'post',
      data
    })
  }
  